import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { refundMethods as REFUND_METHODS } from '@reveni-io/reveni-ui'

import SortableRefundMethod from './SortableRefundMethod'
import * as Styles from './styles'

const SortableRefundMethodsList = ({
  refundMethods,
  savedRefundMethods,
  expandedRefundMethodIds,
  onToggleExpanded,
  dragging,
  onChangeEnabled,
  isEditable,
  isSortable,
  currency,
  onSortEnd,
  onSortStart,
  allowInstantTransactions,
  languages,
  subscriptionPlan,
  storeCurrencySymbol,
  provider,
  errors,
  onChange,
}) => {
  const sensors = useSensors(useSensor(PointerSensor))

  const isRefundMethodEditable = refundMethod => {
    if (refundMethod.name === REFUND_METHODS.bankTransfer && allowInstantTransactions === false) return false

    return isEditable
  }

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSortEnd} onDragStart={onSortStart}>
      <SortableContext items={refundMethods} strategy={verticalListSortingStrategy}>
        <Styles.RefundMethodsContainer>
          {refundMethods.map(refundMethod => (
            <SortableRefundMethod
              key={refundMethod.id}
              refundMethod={refundMethod}
              savedRefundMethod={savedRefundMethods.find(saved => saved.id === refundMethod.id)}
              isExpanded={expandedRefundMethodIds.includes(refundMethod.id)}
              onToggleExpanded={onToggleExpanded}
              dragging={dragging}
              onChangeEnabled={onChangeEnabled}
              isEditable={isRefundMethodEditable(refundMethod)}
              isSortable={isSortable}
              currency={currency}
              languages={languages}
              subscriptionPlan={subscriptionPlan}
              allowInstantTransactions={allowInstantTransactions}
              storeCurrencySymbol={storeCurrencySymbol}
              provider={provider}
              errors={errors[refundMethod.name]}
              onChange={onChange}
            />
          ))}
        </Styles.RefundMethodsContainer>
      </SortableContext>
    </DndContext>
  )
}

export default SortableRefundMethodsList
